<div class="container">
  <div class="card">
    <div *ngIf="error === 404" class="not-found-content">
      <img src="/assets/icon/robot.svg" />
      <div class="mt-16 main-text">
        Oops!
        <p>Something's missing.</p>
      </div>
      <div class="mt-8 sub-text">
        <p>We can't find the page you're looking for.</p>
        <p>Please check the URL to make sure the path is correct.</p>
      </div>
    </div>
    <div *ngIf="error === 401" class="error-content">
      <img src="/assets/icon/glass.svg" />
      <div class="mt-16 main-text">
        Oops!
        <p>We couldn't find this page.</p>
      </div>
      <!-- <div class="mt-8 sub-text">
          <p> Your invitation link has expired. </p>
          <p> 
            Please 
            <a href="mailto:campaign.support@snagajob.com?subject=I'm having trouble accessing Marketplace!">
              contact your administrator
            </a>
            for a new invitation.
          </p>
      </div> -->
      <button mat-button class="mt-24" color="action" (click)="requestLogin()">
        Log Off
      </button>
    </div>
    <div *ngIf="error === 412" class="error-content">
      <img src="/assets/icon/glass.svg" />
      <div class="mt-16 main-text">
        Oops!
        <p>Invalid username or password.</p>
      </div>
      <button mat-button class="mt-24" color="action" (click)="requestLogin()">
        Try Again
      </button>
    </div>
  </div>
</div>
